import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputGroup, FormControl } from 'react-bootstrap';

import { Form } from 'ui/components';
import { currencyFormat, formatDate } from 'utilities/common';
import { SkeletonText, SkeletonTable } from 'ui/components/skeleton';
import { Order } from 'services/action';

import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore';

const initialState = {
  search: '',
  orders: [],
  checkedAll: false
};

export const FormOrders = ({
  data,
  onChange,
  customer,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const isLoading = useSelector(
    (state) => state?.Activity?.services['Order.Get']
  );

  const [{ search, orders, checkedAll }, setState] = React.useState(initialState);

  const $handleCheckedAll = async (e) => {
    let newItems = [...orders];

    _.each(newItems, function(i) {
      i.checked = checkedAll ? false : true
    })

    setState((prevState) => ({ ...prevState, orders: newItems, checkedAll: checkedAll ? false: true }));
  }

  const $handleItemsChange = async (i, e) => {
    let newItems = [...orders];

    newItems[i]['checked'] = orders[i].checked ? false : true;

    setState((prevState) => ({ ...prevState, orders: newItems }));
  };

  const queryArea = () => {
    let query = {
      page: 1,
      limit: 100000000,
      document_status: 'delivered',
      payment_status: 'unpaid',
      customer_id: customer?.id,
      order_by: '-created_at',
      search: search
    };

    return query;
  };

  const $setup = async () => {
    const so = await $setupOrders();
    const sio = await $setupInvoiceOrder();

    setState((prevState) => ({ ...prevState, orders: [...sio, ...so] }));
  }

  const $setupOrders = async () => {
    const res = await Dispatch(Order.$get(queryArea()));

    if (res && res?.message === 'success') {
      let newData = [];

      await res?.data?.forEach((data) => {
        const payload = {
          order_id: data?.id,
          code: data?.code,
          service_type: data?.service_type,
          sender: data?.shipper,
          pickup_address: data?.pickup_address,
          created_at: data?.created_at,
          total_charges: data?.total_charges,
          checked: false,
        };

        newData?.push(payload);
      });

      return newData
    }

    return []
  };

  const $setupInvoiceOrder = async () => {
    if (!data) return [];


    const res = await Dispatch(Order.$getByInvoice(data?.id))
    if (res && res?.message === 'success') {
      let newData = [];

      let x = data?.invoice_orders;

      await res?.data?.forEach((data) => {
        const payload = {
          order_id: data?.id,
          code: data?.code,
          service_type: data?.service_type,
          sender: data?.shipper,
          pickup_address: data?.pickup_address,
          created_at: data?.created_at,
          total_charges: data?.total_charges,
          checked: false,
        };

        x?.map((y) => {
          if (data?.id === y?.orders?.id) {
            payload.invoice_order_id = y?.id
            payload.checked = true
          }
          return true;
        });

        newData?.push(payload);
      })

      return newData
    }

    return []
  }

  React.useEffect(() => {
    let newOrders = [];

    if (orders) {
      orders?.forEach((order) => {
        if (order?.checked) {
          newOrders.push({
            id: order?.invoice_order_id,
            order_id: order?.order_id,
            total_charges: order?.total_charges
          });
        }
      });
    }

    onChange(newOrders);
  }, [orders]);

  React.useEffect(() => {
    if (!customer) {
      setState((prevState) => ({ ...prevState, orders: [] }));
    } else {
      $setup();
    }
  }, [customer, search])

  if (!orders || orders?.length === 0) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">
            {!customer ? 'Customer belum dipilih' : 'Hasil tidak ditemukan'}
          </p>
          {!customer ? (
            <p className="empty-subtitle text-muted">
              Silakan pilih customer terlebih dahulu. <br /> Daftar order
              yang belum dibayar akan muncul disini.
            </p>
          ) : (
            <p className="empty-subtitle text-muted">
              Coba sesuaikan pencarian atau filter Anda untuk menemukan apa yang
              Anda cari.
              <br /> Atau mungkin belum ada datanya!
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="col-12 px-3 ">
        <div>
          <div
            className="fw-semibold py-2 border-bottom mb-3"
            style={{ fontSize: 13 }}
          >
            {isLoading ? (
              <div style={{ width: 250 }}>
                <SkeletonText count={1} />
              </div>
            ) : (
              <>
                <div className='d-flex justify-content-between'>
                  <div className='col-8'>
                    <span>Daftar Order</span>
                  </div>
                  <div className='col-4'>
                    <InputGroup className="search flex-nowrap input-group-flat bg-light">
                      <FormControl
                        placeholder="Cari ..."
                        value={search}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            search: e.target.value,
                          }))
                        }
                        className="bg-light"
                      />
                      <div className="input-group-text">
                        {search ? (
                          <Fi.FiX
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                search: '',
                              }))
                            }
                          />
                        ) : (
                          <Fi.FiSearch />
                        )}
                      </div>
                    </InputGroup>
                  </div>
                </div>
              </>

            )}
          </div>
          {isLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <>
              <div className="table-responsive m-0" style={{maxHeight: '550px'}}>
                <table
                  width="100%"
                  className={cn(
                    'table table-hover table-vcenter card-table datatable border',
                    StateForm?.errors?.orders ? 'border-danger' : ''
                  )}
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td>
                        {orders && (
                          <Form.Checkbox
                            value={checkedAll}
                            onChange={(e) => $handleCheckedAll(e)}
                            iconSize={18}
                          />
                        )}
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '200px' }}>
                        Kode
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '200px' }}>
                        Tipe Layanan
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '200px',
                        }}
                      >
                        Pengirim
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '200px',
                        }}
                      >
                        Alamat Pickup
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '200px',
                          textAlign: 'right',
                        }}
                      >
                        Total Harga
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {orders?.map((s, i) => (
                      <tr
                        key={i}
                        className={cn(
                          StateForm?.errors[`orders.${i}.order_id`]
                            ? 'text-danger border-danger'
                            : null
                        )}
                      >
                        <td>
                          <Form.Checkbox
                            onChange={(e) => $handleItemsChange(i, e)}
                            value={s?.checked}
                            iconSize={18}
                          />
                        </td>
                        <td style={{ whiteSpace: 'initial', width: '200px' }}>
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.code}
                            </div>
                            <small className="info text-uppercase">
                              {formatDate(s?.created_at, 'DD/MM/YYYY')}
                            </small>
                          </div>
                          {StateForm?.errors[`orders.${i}.order_id`] ? (
                            <div className="invalid-feedback d-block ">
                              {StateForm?.errors[`orders.${i}.order_id`]}
                            </div>
                          ) : null}
                        </td>
                        <td style={{ whiteSpace: 'initial', width: '200px' }}>
                          <div>{s?.service_type?.name}</div>
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '200px',
                          }}
                        >
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.sender?.name}
                            </div>
                            <small className="info text-uppercase">
                              {s?.sender?.address}
                            </small>
                          </div>
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '200px',
                          }}
                        >
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.pickup_address?.name}
                            </div>
                            <small className="info text-uppercase">
                              {s?.pickup_address?.region?.district_name},{' '}
                              {s?.pickup_address?.region?.regency_name}
                            </small>
                          </div>
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '200px',
                            textAlign: 'right',
                          }}
                        >
                          {currencyFormat(s?.total_charges)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {StateForm?.errors?.orders ? (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.orders}
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
